function cov_1aenso0yh() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/helpers/addressValidation.ts";
  var hash = "ad653fc2b1380dc3a9f93154366f112aa5936257";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/helpers/addressValidation.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 30
        },
        end: {
          line: 3,
          column: 68
        }
      },
      "1": {
        start: {
          line: 28,
          column: 56
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "2": {
        start: {
          line: 63,
          column: 37
        },
        end: {
          line: 74,
          column: 1
        }
      },
      "3": {
        start: {
          line: 64,
          column: 19
        },
        end: {
          line: 64,
          column: 47
        }
      },
      "4": {
        start: {
          line: 65,
          column: 20
        },
        end: {
          line: 65,
          column: 68
        }
      },
      "5": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 73,
          column: 4
        }
      },
      "6": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 72,
          column: 7
        }
      },
      "7": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 51
        }
      },
      "8": {
        start: {
          line: 76,
          column: 31
        },
        end: {
          line: 133,
          column: 1
        }
      },
      "9": {
        start: {
          line: 79,
          column: 37
        },
        end: {
          line: 79,
          column: 39
        }
      },
      "10": {
        start: {
          line: 80,
          column: 20
        },
        end: {
          line: 80,
          column: 27
        }
      },
      "11": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 112,
          column: 3
        }
      },
      "12": {
        start: {
          line: 84,
          column: 39
        },
        end: {
          line: 84,
          column: 72
        }
      },
      "13": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 98,
          column: 5
        }
      },
      "14": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 39
        }
      },
      "15": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 97,
          column: 8
        }
      },
      "16": {
        start: {
          line: 99,
          column: 26
        },
        end: {
          line: 99,
          column: 85
        }
      },
      "17": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 111,
          column: 6
        }
      },
      "18": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 119,
          column: 3
        }
      },
      "19": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "20": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 51
        }
      },
      "21": {
        start: {
          line: 121,
          column: 26
        },
        end: {
          line: 121,
          column: 73
        }
      },
      "22": {
        start: {
          line: 124,
          column: 27
        },
        end: {
          line: 124,
          column: 98
        }
      },
      "23": {
        start: {
          line: 124,
          column: 66
        },
        end: {
          line: 124,
          column: 97
        }
      },
      "24": {
        start: {
          line: 125,
          column: 29
        },
        end: {
          line: 125,
          column: 84
        }
      },
      "25": {
        start: {
          line: 127,
          column: 2
        },
        end: {
          line: 132,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 63,
            column: 37
          },
          end: {
            line: 63,
            column: 38
          }
        },
        loc: {
          start: {
            line: 63,
            column: 86
          },
          end: {
            line: 74,
            column: 1
          }
        },
        line: 63
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 5
          }
        },
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        },
        line: 69
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 70,
            column: 28
          },
          end: {
            line: 70,
            column: 29
          }
        },
        loc: {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 51
          }
        },
        line: 71
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 76,
            column: 31
          },
          end: {
            line: 76,
            column: 32
          }
        },
        loc: {
          start: {
            line: 78,
            column: 39
          },
          end: {
            line: 133,
            column: 1
          }
        },
        line: 78
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 124,
            column: 55
          },
          end: {
            line: 124,
            column: 56
          }
        },
        loc: {
          start: {
            line: 124,
            column: 66
          },
          end: {
            line: 124,
            column: 97
          }
        },
        line: 124
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 65,
            column: 20
          },
          end: {
            line: 65,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 20
          },
          end: {
            line: 65,
            column: 62
          }
        }, {
          start: {
            line: 65,
            column: 66
          },
          end: {
            line: 65,
            column: 68
          }
        }],
        line: 65
      },
      "1": {
        loc: {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 69,
            column: 34
          }
        }, {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        }],
        line: 69
      },
      "2": {
        loc: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 112,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 83
      },
      "3": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "4": {
        loc: {
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 89,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 6
          },
          end: {
            line: 86,
            column: 33
          }
        }, {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 38
          }
        }, {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 88,
            column: 39
          }
        }, {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 97
          }
        }],
        line: 86
      },
      "5": {
        loc: {
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 119,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 2
          },
          end: {
            line: 119,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 115
      },
      "6": {
        loc: {
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 115,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 6
          },
          end: {
            line: 115,
            column: 67
          }
        }, {
          start: {
            line: 115,
            column: 71
          },
          end: {
            line: 115,
            column: 95
          }
        }],
        line: 115
      },
      "7": {
        loc: {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 116
      },
      "8": {
        loc: {
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 8
          },
          end: {
            line: 116,
            column: 22
          }
        }, {
          start: {
            line: 116,
            column: 27
          },
          end: {
            line: 116,
            column: 77
          }
        }],
        line: 116
      },
      "9": {
        loc: {
          start: {
            line: 121,
            column: 31
          },
          end: {
            line: 121,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 121,
            column: 31
          },
          end: {
            line: 121,
            column: 50
          }
        }, {
          start: {
            line: 121,
            column: 54
          },
          end: {
            line: 121,
            column: 56
          }
        }],
        line: 121
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ad653fc2b1380dc3a9f93154366f112aa5936257"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1aenso0yh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1aenso0yh();
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-collections.iterator.js";
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { listUnits, standardizeAddress } from "./api.mjs";
var UNIVERSAL_NIL_ADDRESS = (cov_1aenso0yh().s[0]++, '6aae647b-d603-5533-8464-c42c658b101a');
export { UNIVERSAL_NIL_ADDRESS };

// TODO: Duplicated here like other places in cinderblocks. Until we figure out
// how to share GraphQL codegen.

export var ADDRESS_INVALID_RESULT = (cov_1aenso0yh().s[1]++, ['ADDRESS_NIL', 'ADDRESS_UNKNOWN', 'ADDRESS_MISSING_PREMISE', 'ADDRESS_INVALID_PREMISE', 'ADDRESS_NOT_SUPPORTED', 'ADDRESS_NOT_REAL', 'ADDRESS_INVALID', 'ADDRESS_INVALID_STREET', 'ADDRESS_INVALID_SUB_PREMISE', 'ADDRESS_MISSING_BOX_NUMBER', 'ADDRESS_INVALID_BOX_NUMBER', 'ADDRESS_EXTRANEOUS_INPUT']);
cov_1aenso0yh().s[2]++;
var doesAddressHaveMultipleUnits = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(addressUuid) {
    var _response$data;
    var response, addresses;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          cov_1aenso0yh().f[0]++;
          cov_1aenso0yh().s[3]++;
          _context.n = 1;
          return listUnits(addressUuid);
        case 1:
          response = _context.v;
          addresses = (cov_1aenso0yh().s[4]++, (cov_1aenso0yh().b[0][0]++, response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.casa) === null || _response$data === void 0 || (_response$data = _response$data.listUnits) === null || _response$data === void 0 ? void 0 : _response$data.addresses) || (cov_1aenso0yh().b[0][1]++, []));
          cov_1aenso0yh().s[5]++;
          return _context.a(2, addresses.some(function (address) {
            var _address$result;
            cov_1aenso0yh().f[1]++;
            cov_1aenso0yh().s[6]++;
            return (cov_1aenso0yh().b[1][0]++, address.uuid !== addressUuid) && (cov_1aenso0yh().b[1][1]++, !((_address$result = address.result) !== null && _address$result !== void 0 && _address$result.some(function (casaResult) {
              cov_1aenso0yh().f[2]++;
              cov_1aenso0yh().s[7]++;
              return ADDRESS_INVALID_RESULT.includes(casaResult);
            })));
          }));
      }
    }, _callee);
  }));
  return function doesAddressHaveMultipleUnits(_x) {
    return _ref.apply(this, arguments);
  };
}();
cov_1aenso0yh().s[8]++;
export var validateAddress = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(address) {
    var _casaAddress, _casaAddress2, _casaAddress3;
    var moreResult, casaAddress, _standardizeAddressRe, _standardizeAddressRe2, standardizeAddressResponse, addressResult, combinedResults, needsManualEntry, needsUnitSelection, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          cov_1aenso0yh().f[3]++;
          moreResult = (cov_1aenso0yh().s[9]++, []);
          casaAddress = (cov_1aenso0yh().s[10]++, address); // Standardize Google addresses to Casa format
          cov_1aenso0yh().s[11]++;
          if (!(address.source === 'google')) {
            _context2.n = 4;
            break;
          }
          cov_1aenso0yh().b[2][0]++;
          cov_1aenso0yh().s[12]++;
          _context2.n = 1;
          return standardizeAddress(address);
        case 1:
          standardizeAddressResponse = _context2.v;
          cov_1aenso0yh().s[13]++;
          if (!((cov_1aenso0yh().b[4][0]++, !standardizeAddressResponse) || (cov_1aenso0yh().b[4][1]++, !standardizeAddressResponse.data) || (cov_1aenso0yh().b[4][2]++, standardizeAddressResponse.errors) || (cov_1aenso0yh().b[4][3]++, ((_standardizeAddressRe = standardizeAddressResponse.data) === null || _standardizeAddressRe === void 0 || (_standardizeAddressRe = _standardizeAddressRe.casa.findByFields) === null || _standardizeAddressRe === void 0 || (_standardizeAddressRe = _standardizeAddressRe.address) === null || _standardizeAddressRe === void 0 ? void 0 : _standardizeAddressRe.uuid) === UNIVERSAL_NIL_ADDRESS))) {
            _context2.n = 2;
            break;
          }
          cov_1aenso0yh().b[3][0]++;
          cov_1aenso0yh().s[14]++;
          moreResult = ['ADDRESS_UNKNOWN'];
          cov_1aenso0yh().s[15]++;
          return _context2.a(2, {
            address: address,
            results: moreResult,
            needsManualEntry: true,
            needsUnitSelection: false
          });
        case 2:
          cov_1aenso0yh().b[3][1]++;
        case 3:
          addressResult = (cov_1aenso0yh().s[16]++, (_standardizeAddressRe2 = standardizeAddressResponse.data) === null || _standardizeAddressRe2 === void 0 || (_standardizeAddressRe2 = _standardizeAddressRe2.casa.findByFields) === null || _standardizeAddressRe2 === void 0 ? void 0 : _standardizeAddressRe2.address);
          cov_1aenso0yh().s[17]++;
          casaAddress = {
            id: addressResult.uuid,
            street1: addressResult.street,
            city: addressResult.city,
            state: addressResult.state,
            postal_code: addressResult.postalCode,
            unit: addressResult.unitNumber,
            result: addressResult.result,
            latitude: address.latitude,
            longitude: address.longitude,
            source: 'casa'
          };
          _context2.n = 5;
          break;
        case 4:
          cov_1aenso0yh().b[2][1]++;
        case 5:
          cov_1aenso0yh().s[18]++;
          if (!((cov_1aenso0yh().b[6][0]++, !((_casaAddress = casaAddress) !== null && _casaAddress !== void 0 && (_casaAddress = _casaAddress.result) !== null && _casaAddress !== void 0 && _casaAddress.includes('ADDRESS_MISSING_SUB_PREMISE'))) && (cov_1aenso0yh().b[6][1]++, ((_casaAddress2 = casaAddress) === null || _casaAddress2 === void 0 ? void 0 : _casaAddress2.unit) === ''))) {
            _context2.n = 10;
            break;
          }
          cov_1aenso0yh().b[5][0]++;
          cov_1aenso0yh().s[19]++;
          _t = (cov_1aenso0yh().b[8][0]++, casaAddress.id);
          if (!_t) {
            _context2.n = 7;
            break;
          }
          cov_1aenso0yh().b[8][1]++;
          _context2.n = 6;
          return doesAddressHaveMultipleUnits(casaAddress.id);
        case 6:
          _t = _context2.v;
        case 7:
          if (!_t) {
            _context2.n = 8;
            break;
          }
          cov_1aenso0yh().b[7][0]++;
          cov_1aenso0yh().s[20]++;
          moreResult = ['ADDRESS_MISSING_SUB_PREMISE'];
          _context2.n = 9;
          break;
        case 8:
          cov_1aenso0yh().b[7][1]++;
        case 9:
          _context2.n = 11;
          break;
        case 10:
          cov_1aenso0yh().b[5][1]++;
        case 11:
          combinedResults = (cov_1aenso0yh().s[21]++, [].concat(_toConsumableArray((cov_1aenso0yh().b[9][0]++, (_casaAddress3 = casaAddress) === null || _casaAddress3 === void 0 ? void 0 : _casaAddress3.result) || (cov_1aenso0yh().b[9][1]++, [])), _toConsumableArray(moreResult))); // Check if address has invalid results
          needsManualEntry = (cov_1aenso0yh().s[22]++, ADDRESS_INVALID_RESULT.some(function (error) {
            cov_1aenso0yh().f[4]++;
            cov_1aenso0yh().s[23]++;
            return combinedResults.includes(error);
          }));
          needsUnitSelection = (cov_1aenso0yh().s[24]++, combinedResults.includes('ADDRESS_MISSING_SUB_PREMISE'));
          cov_1aenso0yh().s[25]++;
          return _context2.a(2, {
            address: casaAddress,
            results: combinedResults,
            needsManualEntry: needsManualEntry,
            needsUnitSelection: needsUnitSelection
          });
      }
    }, _callee2);
  }));
  return function validateAddress(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
//# sourceMappingURL=addressValidation.mjs.map